import { Component, Input } from '@angular/core';

@Component({
  selector: 'com-drop-list-placeholder',
  templateUrl: './drop-list-placeholder.component.html'
})
export class DropListPlaceholderComponent {
  @Input() height = 0;
}
